import { useState, useCallback } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { TYPE_NOTIFICATION } from "../screens/refonte/shares/NotificationBull";
import { Done, InfoOutlined } from "@mui/icons-material";
import { ErrorOutlineOutlined } from "@material-ui/icons";

function useNotification() {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogOptions, setDialogOptions] = useState({
    title: "",
    content: "",
    variant: TYPE_NOTIFICATION.INFO,
    onConfirm: null,
    buttonLabel : 'valider'
  });

  const showNotification = useCallback((title, content, variant, onConfirm,buttonLabel) => {
    setDialogOptions({
      title: title,
      content: content,
      variant: variant,
      onConfirm: onConfirm,
      buttonLabel : buttonLabel || "Valider"
    });
    setIsOpen(true);
  }, []);

  const closeDialog = () => {
    setIsOpen(false);
    setDialogOptions({
      title: "",
      content: "",
      variant: TYPE_NOTIFICATION.INFO,
      onConfirm: null,
      buttonLabel : 'Valider'
    });
  };

  const handleConfirm = () => {
    if (dialogOptions.onConfirm) dialogOptions.onConfirm();
    closeDialog();
  };

  const NotificationComponent = () => (
    <Dialog open={isOpen} /* onClose={closeDialog} */>
      <DialogTitle color={dialogOptions.variant === TYPE_NOTIFICATION.ERROR ? "error" : "primary"}>{dialogOptions.title}</DialogTitle>
      <DialogContent>
        <Grid
          container
          display={"flex"}
          flexDirection={"column"}
          alignItems="center"
          spacing={1}
        >
          <Grid item>
            {dialogOptions.variant === TYPE_NOTIFICATION.WARNING && (
              <WarningAmberIcon
                color="warning"
                fontSize="large"
                sx={{
                  display:
                    dialogOptions.variant === TYPE_NOTIFICATION.WARNING
                      ? ""
                      : "none",
                  width: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                  height: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                }}
              />
            )}
            {dialogOptions.variant === TYPE_NOTIFICATION.ERROR && (
              <ErrorOutlineOutlined
                color="error"
                fontSize="large"
                sx={{
                  display:
                    dialogOptions.variant === TYPE_NOTIFICATION.ERROR
                      ? ""
                      : "none",
                  width: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                  height: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                }}
              />
            )}
            {dialogOptions.variant === TYPE_NOTIFICATION.SUCCESS && (
              <Done
                color="success"
                fontSize="large"
                sx={{
                  width: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                  height: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                }}
              />
            )}
            {dialogOptions.variant === TYPE_NOTIFICATION.INFO && (
              <InfoOutlined
                color="info"
                fontSize="large"
                sx={{
                  width: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                  height: { xs: "3rem", sm: "3.5rem", md: "5rem", lg: "8rem" },
                }}
              />
            )}
          </Grid>
          <Grid ml={2} item>
            <Typography variant="body1" component="div" align="center">
              {dialogOptions.content}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions /* sx={{ justifyContent: "center" }} */>
        <Button onClick={handleConfirm} color="primary">
          {dialogOptions.buttonLabel || "Valider"}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { showNotification, NotificationComponent };
}

export default useNotification;
